import { DataDogRegion } from "./types"

export const dataDogRegionNames: Record<DataDogRegion, string> = {
  [DataDogRegion.US1]: `United States (US1)`,
  [DataDogRegion.US3]: `United States (US3)`,
  [DataDogRegion.US5]: `United States (US5)`,
  [DataDogRegion.EU1]: `European Union (EU1)`,
  [DataDogRegion.GOV]: `Government (US1-FED)`,
}

export const dataDogBaseUrls: Record<DataDogRegion, string> = {
  [DataDogRegion.US1]: `https://http-intake.logs.datadoghq.com/v1/input`,
  [DataDogRegion.US3]: `https://http-intake.logs.us3.datadoghq.com/v1/input`,
  [DataDogRegion.US5]: `https://http-intake.logs.us5.datadoghq.com/v1/input`,
  [DataDogRegion.EU1]: `https://http-intake.logs.datadoghq.eu/v1/input`,
  [DataDogRegion.GOV]: `https://http-intake.logs.ddog-gov.datadoghq.com/v1/input`,
}
